module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-thinking.695fa99f.png";